// extracted by css-extract-rspack-plugin
var _1 = "card-YlwICl";
var _2 = "copy-o3fnt4";
var _3 = "token-_B2zOF";
export { _1 as "card", _2 as "copy", _3 as "token" }
